import axios from "axios";
import apiClient from "./apiClient";

export const addDeed = (deedJson) => apiClient.post("/api/deeds", deedJson);

export const updateDeed = (id, deedJson) =>
  apiClient.put(`/api/deeds/${id}`, deedJson);

export const getDeeds = () => apiClient.get("/api/deeds");

export const deleteDeed = (id) => apiClient.delete(`/api/deeds/${id}`);

export const getDeedSuggestions = () => apiClient.get("/api/deeds/suggestions");

// Renames a bucket for the current user. If `to` already exists as a
// separate bucket for the user, the two are merged (all deeds tagged with
// `from` get re-pointed at `to`). Single round-trip; atomic server-side.
export const renameBucket = (from, to) =>
  apiClient.patch("/api/buckets/rename", { from, to });

export const requestUploadUrl = ({ filename, contentType, deedId }) =>
  apiClient.post("/api/deeds/upload-url", { filename, contentType, deedId });

// Uploads bytes to Supabase Storage via the signed PUT URL the API returned.
// Bypasses apiClient on purpose so the Supabase Authorization header isn't
// attached (Storage rejects unrecognized headers on signed URLs).
export const uploadFileToSupabase = (signedUrl, file) =>
  axios.put(signedUrl, file, {
    headers: {
      "Content-Type": file.type,
      "x-upsert": "false",
    },
  });

// Removes a single object from the deed-pics bucket. The API enforces that
// the path begins with the caller's user id.
export const deleteImage = (path) =>
  apiClient.post("/api/deeds/delete-image", { path });
